export default __webpack_public_path__ + "a61f4ad30a1f3f439424a89aec9a4fc0.svg";